<template>
  <section id="intro">
    <carousel
      :nav="false"
      :dots="false"
      :items="10"
      :autoplay="true"
      :loop="true"
      :autoHeight="true"
      id="intro-carousel"
      style="margin-top:-50px;"
      :responsive="{ 0: { items: 1, nav: false }, 600: { items: 1, nav: false } }"
    >
      <div v-for="(image, i) in resortImages" :key="i">
        <img class="item" style="object-fit:cover" :src="image" :key="i" />
      </div>
    </carousel>
  </section>
</template>

<script>
/* eslint-disable */
import carousel from "vue-owl-carousel";
export default {
  components: {
    carousel
  },
  props: {
    resortImages: {}
  },
  data() {
    return {
      images: []
    };
  },
  async created() {
    this.images = await this.resortImages;
  }
};
</script>

<style lang="scss" scoped></style>
